import { HttpInterceptorFn } from '@angular/common/http';

export const attachJwtTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('jwt');
  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'X-TPL-Cache-Bypass': '1',
      },
    });
  }

  return next(req);
};
